<template>
  <main-large-dialog
    :is-visible.sync="computedIsVisible"
    v-bind="$props"
    :title="additionalModuleName"
    header-shadow
    dialog-width="40%"
    max-height="50vh"
    :has-agree="false"
    disagree-text="dialog.disagreeClose"
  >
    <template #body>
      <v-col cols="12" v-if="isFetched">
        <template v-if="computedCategories[0].links.length === 0 && computedCategories[1].links.length === 0">
          <div>{{ $i18n.t('errors.exportIntercadNoData') }}</div>
        </template>
        <template v-else>
          <v-row no-gutters v-for="(section, index) in computedCategories" :key="index">
            <v-col cols="auto">
              <div class="sectionTitle">{{ $i18n.t(`dialog.intercad.${section.title}`) }}</div>
              <div class="linkRow" v-for="(link, i) in section.links" :key="i">
                {{ link.verbose_name }}
                <span v-if="link.isDownloading" class="pl-2">
                  <main-loader size="35" />
                </span>
                <v-btn icon @click="handleDownload(link)" class="ml-2" v-else>
                  <v-icon color="rgba(0,0,0,0.7)" size="21">
                    mdi-download
                  </v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </template>
      </v-col>
      <v-col cols="12" v-else>
        <main-loader />
      </v-col>
    </template>
  </main-large-dialog>
</template>

<script>
import { call, get } from 'vuex-pathify';
import MainLoader from '@/components/MainLoader';
import MainLargeDialog from '@/components/MainLargeDialog';
export default {
  name: 'ExportInterCadDialog',
  components: { MainLoader, MainLargeDialog },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    isFetched: false,
    computedCategories: [],
  }),
  computed: {
    additionalModuleName: get('admin/additionalModules@INTERCAD_EXPORT.verbose_name'),
    interCadCategories: get('intercad/categories'),
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
  },
  methods: {
    getInterCadCategories: call('intercad/getInterCadCategories'),
    getInterCadData: call('intercad/getInterCadData'),
    async handleDownload(item) {
      item.isDownloading = true;
      try {
        await this.getInterCadData(item.name);
      } catch (e) {
        this.$store.set('snackbar/PUSH_ERROR!', {
          message: this.$i18n.t('errors.exportInterCADFailed'),
        });
      } finally {
        item.isDownloading = false;
      }
    },
    async init() {
      try {
        await this.getInterCadCategories();
        this.computedCategories = this.interCadCategories.map(cat => {
          return {
            title: cat.title,
            links: cat.links.map(link => {
              return {
                ...link,
                isDownloading: false,
              };
            }),
          };
        });
      } finally {
        this.isFetched = true;
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped lang="scss">
.sectionTitle {
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  padding: 0.4rem 0;
}
.linkRow {
  text-align: left;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  padding: 0.2rem 0 0.2rem 2rem;
  display: flex;
  align-items: center;
}
</style>
